module.exports = __webpack_public_path__ + "img/Chevron-up.82b0b92f.svg";